module.exports = __webpack_public_path__ + "img/44-image-1@2x.f6f88ec3.png";